import styled, { css } from 'styled-components'
import { Link } from "react-router-dom";
import { theme } from 'styles/mui-config';

export const StyledLink = styled(Link)`
   text-decoration: none;
`
///////////// Drawer Link //////////////

const activeDrawerLink=({ $isActive }) => {
    if ($isActive) {
        return css`
        background-color:${theme.palette.primary.main};
        & div{
            color:white !important;
        }
        `
    }
}
export const StyledDrawerLink = styled(Link)`
   text-decoration: none;
   display:flex;
   align-items:center;
   width:90%;
   background:#f8f8fa;
   margin-top:10px;
   margin-bottom:10px;
   border-radius:10px;
   ${activeDrawerLink}
`;

